<template>
  <div class="w-full border border-white/10 rounded-md mt-4 bg-white bg-opacity-[3%]">
    <div class="p-2">
      <div class="flex justify-between items-center">
        <p class="text-woodsmoke-50 font-medium">Calculator</p>
        <button @click="showCalculator = !showCalculator" class="btn btn-link text-turquoise-500 btn-xs text-right">{{ showCalculator ? "close" : "open"}}</button>
      </div>

      <div :class="[showCalculator ? 'mt-2' : 'h-0 overflow-hidden', 'transition-all duration-300']">
        <div class="w-full grid grid-cols-6 justify-center items-center gap-4 mb-1">
          <p class="w-full text-sm col-span-3">Refund Percentage</p>
          <div class="col-span-3 flex justify-start items-center space-x-2">
            <URange size="xs" class="w-full" color="primary" v-model="refundPercent" />
            <input v-model="refundPercent" type="text" placeholder="" class="input input-bordered input-xs w-12 text-turquoise-500" />
            <div class="text-sm">%</div>
          </div>
        </div>

        <div class="w-full grid grid-cols-6 justify-center items-center gap-4">
          <p class="w-full text-sm col-span-3">Effective Contribution</p>
          <div class="col-span-3 flex justify-end items-center space-x-2">
            <!-- <input v-model="effectiveContribution" type="text" placeholder="" class="input input-bordered input-xs w-full text-turquoise-500" /> -->
            <p>{{ Number(effectiveContribution).toFixed(2) }}</p>
            <div class="text-sm">USDT</div>
          </div>
        </div>
      </div>
    </div>

    <div :class="[showCalculator ? '' : 'h-0 overflow-hidden', 'transition-all duration-300']">
      <!--<div class="w-full border-t border-t-white/20">
                        <div class="w-full flex justify-between items-center p-2">
                          <p class="text-sm">Diagram</p>
                          <button @click="showDiagram = !showDiagram" class="btn btn-xs btn-link text-turquoise-500">{{ showDiagram ? "minimize" : "show" }}</button>
                        </div>
  
                        <div :class="[showDiagram ? 'h-60' : 'h-0', 'overflow-hidden transition-all duration-300']">
                          <OTCSankey :listingPrice="price" :refundPercentage="refundPercent" :markupValue="markup" />
                        </div>
                      </div>-->

      <div class="w-full border-t border-t-white/20 p-2">
        <div class="w-full flex justify-between items-center text-sm">
          <p class="text-woodsmoke-50">Markup after refund</p>
          <p>
            {{ markup }} USDT x {{ Number(100 - refundPercent).toFixed(2) }}% =
            <span class="text-white">{{ markup * ((100 - refundPercent) / 100) }} USDT</span>
          </p>
        </div>

        <div class="w-full flex justify-between items-center text-sm">
          <p class="text-woodsmoke-50">Fee ({{ feeConstant }}%)</p>
          <p>
            {{ markup * ((100 - refundPercent) / 100) }} USDT X {{ feeConstant }}% =
            <span class="text-white">{{ markup * ((100 - refundPercent) / 100) * (feeConstant / 100) }} USDT</span>
          </p>
        </div>

        <div class="w-full flex justify-between items-center mt-3 text-lg">
          <p class="text-white">Final Profit</p>
          <p class="text-white">{{ markup * ((100 - refundPercent) / 100) * ((100 - feeConstant) / 100) }} USDT</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const markupPercent = ref(0);

const showDiagram = ref(false);
const showCalculator = ref(false);

const refundPercent = ref(0);

const props = defineProps(["price", "allocation", "markup"]);
const { price, allocation, markup } = toRefs(props);

const feeConstant = 5;

const effectiveContribution = ref(0);

onMounted( () => {
  watch(price, () => {
  effectiveContribution.value = price.value - price.value * (refundPercent.value / 100);
});

watch(refundPercent, () => {
  effectiveContribution.value = price.value - price.value * (refundPercent.value / 100);
});
})
</script>

<style></style>
